import React, { useState, useEffect } from "react";
import {
  Tab,
  Tabs,
  Form,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
  Row,
  Col,
} from "react-bootstrap";
import Profile from "../../assets/images/priest-default.png";
import corruptedImg from "../../assets/images/corrupted-img.png";
import PhoneInput from "../../components/PhoneInput";
import CustomDataTable from "../../components/CustomDataTable";
import moment from "moment";
import { toast } from "react-toastify";
import { emailFormatError } from "../../utils/emailFormat";
import { trimIfOnChangeField } from "../../utils/trimFormFields";
import { setBrokenImageFallback } from "../../utils/imageFallback";
import { useEmailDeliverability } from "../../hooks/useEmailDeliverability";
import EmailDeliverabilityStatus from "../../components/EmailDeliverabilityStatus";
import { shouldBlockOnInvalid } from "../../utils/emailDeliverability";
import OtherParishModal from "../../components/OtherParishModal";
import PriestApi from "../../api/priestApi";
import { useNavigate } from "react-router-dom";
import GroupedParishNativeOptions from "../../components/GroupedParishNativeOptions";
import "../../assets/css/LsFormModern.css";

interface UpdatePriestPopUpProps {
  showRegModal?: boolean;
  onHide?: () => void;
  closeButton?: any;
  data?: any;
  isEditAdmin?: boolean;
  parishList?: any[];
  setParishList?: React.Dispatch<React.SetStateAction<any[]>>;
  ediUserIdClicked?: any;
  CloseCompose?: () => void;
  roasterCount?: any;
  userData?: Record<string, any> | null;
  roastersOfPriestList?: any[];
  coupleOldValues?: any;
  setShowREgModal?: (v: boolean) => void;
  setEdiUserIdClicked?: (v: any) => void;
  getAllPriests?: (...args: any[]) => void;
  setData?: React.Dispatch<React.SetStateAction<any>>;
  oldValues?: any;
  setOldValues?: React.Dispatch<React.SetStateAction<any>>;
  isTempUpload?: boolean;
  isTempUpload2?: boolean;
  setIsTempUpload?: (v: boolean) => void;
  retreatDetail?: any;
  redirect?: boolean;
  onSuccess?: ((priest: any) => void) | null;
  [key: string]: any;
}

const UpdatePriestPopUp = ({
  showRegModal,
  onHide,
  closeButton,
  data,
  isEditAdmin,
  parishList,
  setParishList,
  ediUserIdClicked,
  CloseCompose,
  roasterCount,
  userData,
  roastersOfPriestList,
  coupleOldValues,
  setShowREgModal,
  setEdiUserIdClicked,
  getAllPriests,
  setData,
  oldValues,
  setOldValues,
  isTempUpload,
  isTempUpload2,
  setIsTempUpload,
  retreatDetail = null,
  redirect = true,
  onSuccess = null,
}: UpdatePriestPopUpProps) => {
  const [validated, setValidated] = useState<boolean>(false);
  const [oldData, setOldData] = useState<any>({});
  const [otherParishModalOpen, setOtherParishModalOpen] = useState<boolean>(false);
  let priestApi = new PriestApi();
  const [emailErrors, setEmailErrors] = useState<Record<string, any>>({
    email: "",
  });
  const emailStatus = useEmailDeliverability(data?.email || "");
  const navigate = useNavigate();
  const columns1 = [
    {
      id: "title",
      name: "Retreats",
      selector: (row: any) => (
        <div className="titleWithDate">
          {userData && userData.userRole === "SUBADMIN" ? (
            <div>
              {row?.parish}
              {row.language
                ? ` (${row.language[0].toUpperCase()}${row.language.slice(1)}) `
                : null}{" "}
              {row.location
                ? `${row.location[0].toUpperCase()}${row.location.slice(1)}`
                : ""}
            </div>
          ) : (
            <a
              href={`/retreatRoster?retreatId=${row.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="retreat_title"
            >
              <div>
                {row?.parish}
                {row.language
                  ? ` (${row.language[0].toUpperCase()}${row.language.slice(
                      1,
                    )}) `
                  : null}{" "}
                {row.location
                  ? `${row.location[0].toUpperCase()}${row.location.slice(1)}`
                  : ""}
              </div>
            </a>
          )}
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip(
              row?.dateFrom && row?.dateTo
                ? moment(row.dateFrom).format("MMM DD") +
                  " - " +
                  moment(row.dateTo).format("MMM DD") +
                  ", " +
                  moment(row.dateFrom).format("YYYY")
                : "",
            )}
          >
            <span>
              {row?.dateFrom && row?.dateTo
                ? moment(row.dateFrom).format("MMM DD") +
                  " - " +
                  moment(row.dateTo).format("MMM DD") +
                  ", " +
                  moment(row.dateFrom).format("YYYY")
                : ""}
            </span>
          </OverlayTrigger>
        </div>
      ),
      sortable: true,
      reorder: true,
      width: "300px",
    },
    {
      id: "AttendeeType",
      name: "Type",
      selector: (row) => row && row.attendeeType,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.attendeeType)}
        >
          {row && row.attendeeType == "Team" ? (
            <span className="badge badge-danger">{row.attendeeType}</span>
          ) : (
            <span className="badge badge-success">{row.attendeeType}</span>
          )}
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "200px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Role",
      name: "Role",
      selector: (row) => row && row.role,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.role)}
        >
          <span>{row.role ? row.role : ""} (Priest)</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "200px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "Talk",
      name: "Talk",
      selector: (row) => row && row.talk,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.talk)}
        >
          <span>{row.talk ? row.talk : ""}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "230px",
      style: {
        cursor: "text",
      },
    },
  ];

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip">{props}</Tooltip>
  );

  const upload = () => {
    document.getElementById("PriestProfileUpload").click();
    setIsTempUpload(true);
  };

  const remove = () => {
    let d = { ...data };
    d.imageUrl = "";
    setData(d);
    setIsTempUpload(false);
  };

  const handleChanges = (e: any) => {
    let { name, value } = e.target;
    if (typeof value === "string") value = trimIfOnChangeField(name, value);
    let d = { ...data };
    let o = { ...oldData };

    if (name === "title") {
      o.title = oldValues.title;
    } else if (name === "firstName") {
      o.firstName = oldValues.firstName;
    } else if (name === "lastName") {
      o.lastName = oldValues.lastName;
    } else if (name === "email") {
      o.email = oldValues.email;
    } else if (name === "parishId") {
      if (value === "OTHER") {
        setOtherParishModalOpen(true);
      }
      if (value === "") {
        value = retreatDetail?.parishId || "";
      }
      d.parishId = value;
      o.parishId = oldValues.parishId;

      // Auto-populate address fields from parish data
      const selectedParish = parishList.find((p) => p.id === parseInt(value));
      if (selectedParish) {
        d.address = selectedParish.address || "";
        d.city = selectedParish.city || "";
        d.state = selectedParish.state || "";
        d.zip = selectedParish.zip || "";
      } else {
        d.address = "";
        d.city = "";
        d.state = "";
        d.zip = "";
      }
    }
    setOldData(o);

    // ONLY FOR UPLOAD PRIEST IMAGE
    if (name === "imageUrl") {
      const file = e.target.files[0];
      if (file) {
        const fileSizeInMB = file.size / (1024 * 1024); // Convert size from bytes to MB
        if (fileSizeInMB > 3) {
          alert("File size should be less than 3 MB");
          return;
        } else {
          d[name] = file;
          const successMessage =
            name === "imageUrl"
              ? "The profile image has been successfully added."
              : "";
          toast.success(successMessage);
        }
      }
    } else {
      d[name] = value;
    }
    setData(d);

    if (name === "email") {
      setEmailErrors((prev) => ({
        ...prev,
        [name]: emailFormatError(value),
      }));
    }
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    if (emailErrors.email) {
      toast.error("Please enter a valid email address.");
      return;
    }
    if (shouldBlockOnInvalid(emailStatus)) {
      toast.error("Please enter a valid email.");
      return;
    }

    if (form.checkValidity()) {
      if (
        ediUserIdClicked &&
        ediUserIdClicked !== "" &&
        ediUserIdClicked !== null
      ) {
        let data1 = new FormData();
        if (data.imageUrl !== "") {
          data1.append("file", data.imageUrl);
        }
        let stateRef = { ...data };
        if (stateRef.parishId === "" || stateRef.parishId === null) {
          stateRef.parishId = retreatDetail.parishId || "";
        }
        data1.append("fromData", JSON.stringify(stateRef));
        priestApi
          .editPriest(data1)
          .then(async (res) => {
            if (res.success) {
              toast.success(res.msg);
              if (redirect) {
                navigate("/priest-list");
              } else {
                getAllPriests && getAllPriests();
                if (CloseCompose) {
                  CloseCompose();
                } else if (onHide) {
                  onHide();
                }
              }
              if (onSuccess) {
                onSuccess(res.data);
              }
              if (
                oldData.firstName ||
                (oldData.firstName === "" &&
                  oldData.firstName !== res.data.firstName)
              ) {
                
              }
              if (
                oldData.lastName ||
                (oldData.lastName === "" &&
                  oldData.lastName !== res.data.lastName)
              ) {
                
              }

              if (
                oldData.email ||
                (oldData.email === "" && oldData.email !== res.data.email)
              ) {
                
              }

              let oldparish = parishList.find((i) => i.id === oldData.parishId);
              let newparish = parishList.find(
                (i) => i.id === res.data.parishId,
              );
              if (oldData.parishId || oldData.parishId === null) {
                
              }

              if (
                oldData.notes ||
                (oldData.notes === "" && oldData.notes !== res.data.notes)
              ) {
                
              }

              if (
                oldData.zip ||
                (oldData.zip === "" && oldData.zip !== res.data.zip)
              ) {
                
              }

              if (
                oldData.city ||
                (oldData.city === "" && oldData.city !== res.data.city)
              ) {
                
              }

              if (
                oldData.state ||
                (oldData.state === "" && oldData.state !== res.data.state)
              ) {
                
              }

              if (
                oldData.imageUrl ||
                (oldData.imageUrl === "" &&
                  oldData.imageUrl !== res.data.imageUrl)
              ) {
                
              }

              if (
                oldData.address ||
                (oldData.address === "" && oldData.address !== res.data.address)
              ) {
                
              }

              clearfield();
              setData({
                id: "",
                title: "",
                firstName: "",
                lastName: "",
                email: "",
                city: "",
                state: "",
                zip: "",
                imageUrl: "",
                parishId: null,
                address: "",
              });
              setOldData([]);
              setShowREgModal(false);
              setEdiUserIdClicked("");
              getAllPriests();
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error) => {
            toast.error(error);
          });
      } else {
        let data1 = new FormData();
        data1.append("file", data.imageUrl);
        let stateRef = { ...data };
        if (stateRef?.parishId === "" || stateRef?.parishId === null) {
          stateRef.parishId = retreatDetail?.parishId || "";
        }
        delete stateRef.imageUrl;
        data1.append("fromData", JSON.stringify(stateRef));
        priestApi
          .createPriest(data1)
          .then(async (res) => {
            if (res.success) {
              
              if (redirect) {
                navigate("/priest-list");
              } else {
                getAllPriests && getAllPriests();
                if (CloseCompose) {
                  CloseCompose();
                } else if (onHide) {
                  onHide();
                }
              }
              if (onSuccess) {
                onSuccess(res.data);
              }
              toast.success(res.msg);
              clearfield();
              setEdiUserIdClicked("");
              setShowREgModal(false);
              getAllPriests();
              remove();
              setData({
                id: "",
                firstName: "",
                lastName: "",
                email: "",
                city: "",
                state: "",
                zip: "",
                imageUrl: "",
                address: "",
              });
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
    setValidated(true);
  };

  const clearfield = () => {
    setData({
      id: "",
      parishId: null,
      title: "",
      firstName: "",
      lastName: "",
      email: "",
      city: "",
      state: "",
      zip: "",
      imageUrl: "",
      address: "",
    });
    setValidated(false);
  };

  return (
    <div className="tab_headers ls-form">
      <Modal
        show={showRegModal}
        onHide={onHide}
        size="lg"
        centered
        contentClassName="ls-form-modal-content"
      >
        <Modal.Header closeButton={closeButton}>
          <Modal.Title>
            {ediUserIdClicked && ediUserIdClicked !== ""
              ? "Edit Spiritual Director (Priest/Deacon)"
              : "Add Spiritual Director (Priest/Deacon)"}
          </Modal.Title>
        </Modal.Header>
        <Tabs
          defaultActiveKey="Spiritual Director (Priest) Details"
          id="uncontrolled-tab-example"
        >
          <Tab
            eventKey="Spiritual Director (Priest) Details"
            title="Spiritual Director (Priest/Deacon) Details"
            className="tab-content"
          >
            <Form
              onSubmit={handleSubmit}
              noValidate
              validated={validated}
              className="forms-sample ls-form"
            >
              <Modal.Body>
                <p className="card-description">Enter priest details here..</p>
                <div className="ls-form-section">
                  <h3 className="ls-form-section-title">Identity</h3>
                  <div className="ls-form-identity">
                    <div>
                      <Form.Group>
                        <Form.Label>Priest Id</Form.Label>
                        <Form.Control
                          required
                          size="sm"
                          type="text"
                          name="primaryKey"
                          id="primaryKey"
                          placeholder="Priest Id"
                          value={data.primaryKey}
                          className="form-control"
                          onChange={(e) => handleChanges(e)}
                          readOnly
                        />
                        <Form.Control.Feedback type="invalid">
                          Priest Id is required!
                        </Form.Control.Feedback>
                      </Form.Group>
                    </div>
                    <div className="ls-form-avatar">
                      {data.imageUrl == "" || data.imageUrl == undefined ? (
                        <div className="edit-profile-img mandatoryImage mb-2 text-center">
                          <img src={Profile} />
                        </div>
                      ) : (
                        <div
                          className={`edit-profile-img ${
                            data?.imageUrl ? null : "mandatoryImage"
                          } mb-2 text-center`}
                        >
                          {isTempUpload ? (
                            <>
                              <img
                                src={URL.createObjectURL(data?.imageUrl)}
                                onError={(e) => setBrokenImageFallback(e, corruptedImg)}
                              />
                            </>
                          ) : (
                            <>
                              <img
                                src={data?.imageUrl || data?.priestImage}
                                onError={(e) => setBrokenImageFallback(e, corruptedImg)}
                              />
                            </>
                          )}
                        </div>
                      )}
                      <div className="text-center">
                        {data.imageUrl == "" || data.imageUrl == undefined ? (
                          <>
                            <input
                              name="imageUrl"
                              className="pt-1"
                              type="file"
                              accept="image/*"
                              style={{ display: "none" }}
                              id="PriestProfileUpload"
                              onChange={(e) => handleChanges(e)}
                            />
                            <Button
                              variant="primary"
                              className="mb-1 text-center"
                              onClick={(e) => {
                                upload();
                              }}
                            >
                              Upload Profile Image
                            </Button>
                          </>
                        ) : userData &&
                          userData.userRole === "SUBADMIN" ? null : (
                          <Button
                            variant="danger"
                            className="mb-1 mt-2 "
                            onClick={(e) => {
                              remove();
                            }}
                          >
                            Remove
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="ls-form-section">
                  <h3 className="ls-form-section-title">Priest information</h3>
                    <Row>
                      <Col lg={6} md={6} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label
                            className={data.parishId ? null : "highlightField"}
                          >
                            Parish <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Select
                            required
                            size="sm"
                            name="parishId"
                            value={data.parishId || ""}
                            onChange={(e) => handleChanges(e)}
                          >
                            <GroupedParishNativeOptions
                              parishList={parishList}
                              includeNoneOther
                            />
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Parish is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={2} md={2} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label
                            className={data.title ? null : "highlightField"}
                          >
                            Title <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Select
                            required
                            size="sm"
                            name="title"
                            id="title"
                            value={data.title}
                            onChange={(e) => handleChanges(e)}
                            {...({ readOnly: isEditAdmin } as any)}
                          >
                            <option value="">Title</option>
                            <option value="Fr.">Fr.</option>
                            <option value="Rev.">Rev.</option>
                            <option value="Msgr.">Msgr.</option>
                            <option value="Dcn.">Dcn.</option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Title is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={4} md={4} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label
                            className={data.firstName ? null : "highlightField"}
                          >
                            First Name <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            required
                            size="sm"
                            type="text"
                            name="firstName"
                            id="firstName"
                            placeholder="First Name"
                            value={data.firstName}
                            className="form-control"
                            onChange={(e) => handleChanges(e)}
                            readOnly={isEditAdmin}
                          />
                          <Form.Control.Feedback type="invalid">
                            First Name is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={6} md={6} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label
                            className={data.lastName ? null : "highlightField"}
                          >
                            Last Name<span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            required
                            size="sm"
                            type="text"
                            name="lastName"
                            id="lastName"
                            placeholder="Last Name"
                            value={data.lastName}
                            className="form-control"
                            onChange={(e) => handleChanges(e)}
                            readOnly={isEditAdmin}
                          />
                          <Form.Control.Feedback type="invalid">
                            Last Name is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={6} md={6} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Email"
                            value={data.email}
                            onChange={(e) => handleChanges(e)}
                            readOnly={isEditAdmin}
                          />
                          {emailErrors.email && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "12px" }}
                            >
                              {emailErrors.email}
                            </span>
                          )}
                          <EmailDeliverabilityStatus status={emailStatus} />
                          <Form.Control.Feedback type="invalid">
                            Email is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                </div>
                <div className="ls-form-section">
                  <h3 className="ls-form-section-title">Address</h3>
                  <div className="row">
                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      name="address"
                      id="address"
                      placeholder="Address"
                      value={data.address}
                      onChange={(e) => handleChanges(e)}
                      readOnly
                    />
                    <Form.Control.Feedback type="invalid">
                      Address is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <Form.Label>State</Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      name="state"
                      id="state"
                      placeholder="State"
                      value={data.state}
                      onChange={(e) => handleChanges(e)}
                      readOnly
                    />
                    <Form.Control.Feedback type="invalid">
                      State is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      name="city"
                      id="city"
                      placeholder="City"
                      value={data.city}
                      onChange={(e) => handleChanges(e)}
                      readOnly
                    />
                    <Form.Control.Feedback type="invalid">
                      City is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <Form.Label>Zip</Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      name="zip"
                      id="zip"
                      placeholder="Zip"
                      value={data.zip}
                      onChange={(e) => handleChanges(e)}
                      readOnly
                    />
                    <Form.Control.Feedback type="invalid">
                      Zip is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                {userData && userData.userRole === "SUBADMIN" ? null : (
                  <Button variant="primary" type="submit">
                    {ediUserIdClicked && ediUserIdClicked !== ""
                      ? "Update"
                      : "Submit"}
                  </Button>
                )}

                <Button
                  variant="secondary"
                  onClick={() => {
                    if (CloseCompose) {
                      CloseCompose();
                    } else if (onHide) {
                      onHide();
                    }
                  }}
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </Tab>
          <Tab eventKey="Retreats" title="Retreats" className="tab-content">
            <div className="ls-form-section m-3">
              <h3 className="ls-form-section-title">Retreat history</h3>
              <p className="ls-form-section-sub">Total Retreats: {roasterCount}</p>
              <div className="modal_table">
                <CustomDataTable
                  data={roastersOfPriestList}
                  columns={columns1}
                  pointerOnHover={true}
                  highlightOnHover={true}
                />
              </div>
            </div>
          </Tab>
        </Tabs>
      </Modal>
      <OtherParishModal
        show={otherParishModalOpen}
        handleClose={() => setOtherParishModalOpen(false)}
        registerationData={data}
        setRegisterationData={setData}
        setParishList={setParishList}
        parishList={parishList}
      />
    </div>
  );
};

export default UpdatePriestPopUp;
